"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Content", {
  enumerable: true,
  get: function get() {
    return _Content.Content;
  }
});
Object.defineProperty(exports, "Trigger", {
  enumerable: true,
  get: function get() {
    return _Trigger.Trigger;
  }
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var RadixPopover = _interopRequireWildcard(require("@radix-ui/react-popover"));
var _Trigger = require("./Trigger");
var _Content = require("./Content");
var _jsxRuntime = require("react/jsx-runtime");
var PopoverContext = /*#__PURE__*/(0, _react.createContext)(null);
var PopoverHandler = function PopoverHandler(_ref) {
  var children = _ref.children;
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    open = _ref3[0],
    setOpen = _ref3[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PopoverContext.Provider, {
    value: {
      open: open,
      setOpen: setOpen
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RadixPopover.Root, {
      modal: false,
      open: open,
      onOpenChange: setOpen,
      children: children
    })
  });
};
var usePopoverState = function usePopoverState() {
  var currentUserContext = (0, _react.useContext)(PopoverContext);
  if (!currentUserContext) {
    throw new Error('usePopoverState has to be used within <PopoverHandler>');
  }
  return currentUserContext;
};

// ONLY USED FOR STORYBOOK DOCUMENTATION

PopoverHandler.Trigger = _Trigger.Trigger;
PopoverHandler.Content = _Content.Content;
PopoverHandler.usePopoverState = usePopoverState;
var _default = exports.default = PopoverHandler;